import axiosPost from '../axiosPost';

export const feriadosIns = async (arg) => {
    const { nombre } = arg;

    const body = {
        "service": "FeriadoIns",
        "params": {
            "feriadoNombre": nombre
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}